
import React from "react";
import { Button, Modal, Col, Row } from 'react-bootstrap'

class ReportCard extends React.Component {

    constructor(props) {
        super(props);
        this.changeData = this.changeData.bind(this);
        this.state = {
            message: 'ReportCard',
            modalShowEndActivity: false
        };
        // console.log('ReportCard');
        // console.log(this.props);
    }

    changeData(data) {
        if ((!this.props.showDetail && data.attenders) || (this.props.showDetail && this.props.showDetail === 'student')) {
            this.props.referenceCallback(data);
        } else {
            this.setState({modalShowEndActivity : true})
        }
    }

    divtable() {

        // if (this.props.role === "student" || (this.props.showDetail != undefined && this.props.showDetail === 'student')) {

        //     return (
        //         <Row className="blue-bg">
        //             <Col xs={4} md={2} className="text-center gray-text2">วันที่</Col>
        //             <Col xs={8} md={6} className="text-center gray-text2">รายชื่อกิจกรรม</Col>
        //             <Col xs={12} md={4} className="text-left d-none d-md-block d-lg-block">
        //                 <Row>
        //                     <Col xs={12} md={12} className="text-center d-none d-md-inline d-lg-inline gray-text2"></Col>
        //                 </Row>
        //             </Col>
        //         </Row>43
        //     )
        // } else {
        return (
            <Row className="blue-bg d-none d-md-block py-1">
                <Col md={10} className="d-md-flex">
                    <Col md={2} className="text-left gray-text2">วันที่</Col>
                    <Col md={10} className="text-center gray-text2">รายชื่อกิจกรรม</Col>
                </Col>
                <Col md={2} ></Col>
            </Row>
        )
        // }
    }

    exportLink (activityId, attenders = 0) {
        if ((!this.props.showDetail && attenders) || (this.props.showDetail && this.props.showDetail === 'student')) {
            const link = (this.props.showDetail && this.props.showDetail === 'student') ? `/report/pdffile/person/${activityId}/all/${this.props.studentId}` : `/report/pdffile/overview/${activityId}/all`
            window.open(link, '_blank').focus();
        } else {
            this.setState({modalShowEndActivity : true})
        }
    }

    divData() {

        // if (this.props.role === "student" || (this.props.showDetail != undefined && this.props.showDetail === 'student')) {

        //     var data = this.props.dataDetail.map((item, index) => (
        //         <Row key={index.toString()} className="border-bottom-blue  py-3">
        //             <Col xs={4} md={2} className="text-left"><div dangerouslySetInnerHTML={{ __html: item.date }} className="anywhere-wrap" /></Col>
        //             <Col xs={8} md={6} className="text-left">{item.topic}</Col>
        //             <Col xs={12} md={4} className="d-inline">
        //                 <Row>
        //                     <Col xs={12} md={12} className="d-inline">
        //                         <div className="w=100 d-block d-md-none d-lg-none py-1" ></div>
        //                         <Button className="bluebtn d-inline" onClick={() => this.changeData({ activityId: item.activityId, topicId: item.topicId, date: item.dateString, studentId: '' })}>รายละเอียด</Button><Button className="bluebtn d-inline" onClick={() => this.changeData(item.exports)}>Export</Button>
        //                     </Col>
        //                 </Row>
        //             </Col>
        //         </Row>
        //     ))
        // } else {
        var data = this.props.dataDetail.map((item, index) => (
            <Row key={index.toString()} className="border-bottom-blue  py-3">
                <Col xs={8} md={10} className="d-md-flex px-0 click-pointer" onClick={() => this.changeData({ activityId: item.activityId, topicId: item.topicId, date: item.dateString, studentId: '', attenders: item.attenders })}>
                    <Col xs={12} md={2} className="text-left px-0">
                        <h5 style={{ "color": '#848DA3' }}><div dangerouslySetInnerHTML={{ __html: item.date }} className="anywhere-wrap" /></h5>
                    </Col>
                    <Col xs={12} md={10} className="text-left px-0">
                        <h4>{item.topic}<br></br>
                            <a className="d-inline click-pointer" ><h5 className="font-weight-600 green-text"><u>รายละเอียด</u></h5></a></h4>
                    </Col>
                </Col>
                <Col xs={4} md={2} className="pr-0 d-flex">
                    <Button className="bluesky d-inline py-1 py-1 py-lg-2 px-3 px-lg-5 bt font-sarabun-bold btn btn-primary m-auto" onClick={() => this.exportLink(item.activityId, item.attenders)}><h5 className="mb-0 font-weight-bold">Export</h5></Button>
                </Col>
            </Row>
        ))
        // }


        return data;

    }

    render() {
        return (
            <div className="main-detail px-4">
                {this.divtable()}
                <Row>
                    <hr className="d-block d-md-none w-100 m-0" style={{ "borderTop": '1px solid #D5E3FB' }}></hr>
                </Row>
                {this.divData()}
                <Modal
                show={this.state.modalShowEndActivity}
                onHide={() => { this.setState({modalShowEndActivity : false}) }}
                aria-labelledby="contained-modal-title-vcenter"
                // className="strength-modal"
                centered
                className="alert-modal"
            >
                    <Modal.Body className="font-sarabun text-center py-4">
                        <p>ไม่สามารถดูรายงานได้ <span class="mobile-new-line"></span>เนื่องจากไม่มีผู้ร่วมกิจกรรม</p>
                        <Button className="bluebtn d-inline py-1 py-md-2 px-3 font-sarabun-bold border-radius-10" onClick={() => { this.setState({modalShowEndActivity : false}) }}>ตกลง</Button>
                    </Modal.Body>
            </Modal>
            </div>
        )
    }
}



export default ReportCard